import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS, ENDPOINTS } from 'src/Core/Constant';
import { FullScreenPopupComponent } from '../../Modalla-Popup/full-screen-popup/full-screen-popup.component';
import { NbDialogService } from '@nebular/theme';
import { ConfirmationModalComponent } from '../../Modalla-Popup/confirmation-modal/confirmation-modal.component';
import { FormApprovalSuccessModalComponent } from '../../Modalla-Popup/form-approval-success-modal/form-approval-success-modal.component';
import { environment } from 'src/environments/environment';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-tentative-date',
  templateUrl: './tentative-date.component.html',
  styleUrls: ['./tentative-date.component.scss']
})
export class TentativeDateComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Input() applicantData: any; // Accept data from parent component
  @Output() navigateToFirstTab: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateToInvalidTab = new EventEmitter<any>();
  @Input() ApplicationTypeId :any

  requestedDatesForm!: FormGroup;
  submitted = false;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  isEditable: boolean = true; // Flag to track if the form is editable

  SaveMode = CONSTANTS.SAVE_MODE;
  retreatEventsList: any[] = [];

  constructor(private activatedRoute: ActivatedRoute, private dialogService: NbDialogService,private router: Router, private fb: FormBuilder, private toastr: ToastrService, private api: SevaProfileService, public genericValidations: GenericValidationsService, private translationService: TranslationService) {
  }

  ngOnInit(): void {
    if (!this.isPreviewMode) {
    this.initializeForm();
    this.getApplicantData();
    // Load retreat events if PTH application type
    if (this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH) {
      this.getRetreatEvents();
    }
  }
}


      
ngOnChanges(changes: SimpleChanges): void {
  if (changes['applicantData'] && this.applicantData) {
    this.initializeForm();
    this.requestedDatesForm.patchValue(this.applicantData);
    this.requestedDatesForm.disable();
  }
  
  // Reload retreat events if ApplicationTypeId changes to PTH
  if (changes['ApplicationTypeId'] && this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH) {
    this.getRetreatEvents();
    // Update form validation
    if (this.requestedDatesForm) {
      this.requestedDatesForm.get('RetreatEventId')?.setValidators(Validators.required);
      this.requestedDatesForm.get('RetreatEventId')?.updateValueAndValidity();
    }
  } else if (changes['ApplicationTypeId'] && this.ApplicationTypeId != CONSTANTS.ApplicationTypeId.PTH) {
    // Clear validation if not PTH
    if (this.requestedDatesForm) {
      this.requestedDatesForm.get('RetreatEventId')?.clearValidators();
      this.requestedDatesForm.get('RetreatEventId')?.updateValueAndValidity();
    }
  }
}



  getApplicantData() { 
    let endpoint = '';
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.VISITING_SEVA){
      endpoint = ENDPOINTS.VISITING_SEVA.GET_DATE_OF_ARRIVAL;
    }
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH){
      endpoint = ENDPOINTS.PTH.GET_DATE_OF_ARRIVAL;
    }



    this.api.apiCall(endpoint, 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.requestedDatesForm.disable();
        } else {
          this.requestedDatesForm.enable();
        }

        if (response.Data && response.Data.CommonArrivalScheduleRequestData && response.Data.CommonArrivalScheduleRequestData.length > 0) {
          response.Data.CommonArrivalScheduleRequestData.forEach((arg: any) => {
            arg.RequestedArrivalDate = this.genericValidations.formatDate(new Date(arg.RequestedArrivalDate));
            arg.RequestedDepartureDate = this.genericValidations.formatDate(new Date(arg.RequestedDepartureDate));
          })
        }

        this.requestedDatesForm.patchValue(response.Data);
      }
    })
  }


  initializeForm() {
    // Determine if RetreatEventId is required based on ApplicationTypeId
    const isPTH = this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH;
    
    this.requestedDatesForm = this.fb.group({
      CommonArrivalScheduleRequestData: this.fb.array([
        this.createScheduleGroup(),
        // this.createScheduleGroup(),
        // this.createScheduleGroup(),
      ]),
      SaveMode: ['', Validators.required],
      RetreatEventId: [null, isPTH ? Validators.required : null]
    });

    // Update validation when ApplicationTypeId changes
    if (isPTH) {
      this.requestedDatesForm.get('RetreatEventId')?.setValidators(Validators.required);
    } else {
      this.requestedDatesForm.get('RetreatEventId')?.clearValidators();
    }
    this.requestedDatesForm.get('RetreatEventId')?.updateValueAndValidity();

    this.formGroupChange.emit(this.requestedDatesForm);
  }

  private createScheduleGroup(): FormGroup {
    const group = this.fb.group({
      Id: [0,],
   
      RequestedArrivalDate: [null, Validators.required],
      RequestedDepartureDate: [null, [Validators.required,]],
      SaveMode: ['',],
    }, { validators: this.arrivalBeforeOrEqualDepartureValidator() });
    return group;
  }

  private arrivalBeforeOrEqualDepartureValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const arrival = group.get('RequestedArrivalDate')?.value;
      const departure = group.get('RequestedDepartureDate')?.value;
      if (!arrival || !departure) {
        return null;
      }
      const arrivalDate = new Date(arrival);
      const departureDate = new Date(departure);
      if (isNaN(arrivalDate.getTime()) || isNaN(departureDate.getTime())) {
        return null;
      }
      return arrivalDate.getTime() <= departureDate.getTime() ? null : { dateOrder: true };
    };
  }


  get arrivalScheduleDetails() {
    return this.requestedDatesForm.get('CommonArrivalScheduleRequestData') as FormArray;
  }


OpenModal(cleanedValues: any, Mode: any) {
    const dialogRef = this.dialogService.open(ConfirmationModalComponent, {
      context: {
        data: {
             'title': 'Confirm Submission',
          'message': 'Do you want to review once or submit?',
          'name': 'Chetan',
          'city': "Malegaon",
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res.isApproval === true) {
        this.addUpdate(cleanedValues, Mode);
        // this.FormApproveSucessfully()
        // this.getAllApplication(); 
      } else if (res.isReview === true) {
        this.navigateToFirstTab.emit();
       

       
      }
    });
  }


  onSubmit(Mode: number): void {

    this.requestedDatesForm.patchValue({
      SaveMode: Mode
    })

    if (!this.requestedDatesForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;
      this.requestedDatesForm.markAllAsTouched();
      this.toastr.warning('Please complete all required fields before submitting.');
      return
    }

    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.requestedDatesForm.value);
    if (Mode == this.SaveMode.SAVE) {
      this.OpenModal(cleanedValues, Mode);
    } else {

      this.addUpdate(cleanedValues, Mode);
    }
   
    //this.addUpdate(cleanedValues, Mode);

  }

FormApproveSucessfully() {


    const dialogRef = this.dialogService.open(FormApprovalSuccessModalComponent, {
      context: {
        data: {
          'name': 'Chetan',
          'city': "Malegaon",
          'message':"Application Submitted Successfully"
        }
      },
      closeOnBackdropClick: false,
      hasScroll: true,
    });

    dialogRef.onClose.subscribe(res => {

      if (res === true) {
        this.router.navigate(['/applicant/profile-summary'])
       
      } else {
   
      }
    });

  }



  addUpdate(reqBody: any, Mode: number) {
  // attach SaveMode to each element
  reqBody.CommonArrivalScheduleRequestData.forEach((element: any) => {
    element.SaveMode = Mode;
  });




    let endpoint = '';
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.VISITING_SEVA){
      endpoint = ENDPOINTS.VISITING_SEVA.SAVE_DATE_OF_ARRIVAL;
    }
    if(this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH){
      endpoint = ENDPOINTS.PTH.SAVE_DATE_OF_ARRIVAL;
    }



  this.api.apiCall(endpoint, 'POST', reqBody).subscribe(
    (response: any) => {
      // this.toastr.success(response?.Message);
  
      const completionPercentage = response?.Data?.ProfileCompletionDetails?.CompletionPercentage ?? 0;
      // const status = response?.Data?.ProfileCompletionDetails?.Status ?? '';
      // const incompleteTabs = response?.Data?.IncompleteTabDetails ?? [];
  
      // // check incomplete conditions
      // if (incompleteTabs && incompleteTabs.length > 0) {
      //   this.showIncompleteTabsModal(incompleteTabs);
      // } else {
        this.toastr.success(response?.Message);
        if (Mode === this.SaveMode.SAVE) {
          this.FormApproveSucessfully();
        } else if (Mode === this.SaveMode.DRAFT) {
          this.getApplicantData();
        }
      // }
    },
    (err: any) => {
      console.error('API Error:', err);
      


      // const completionPercentage = err?.error?.Data?.ProfileCompletionDetails?.CompletionPercentage ?? 0;
      const status = err?.error?.Data?.ProfileCompletionDetails?.Status ?? '';
      const incompleteTabs = err?.error?.Data?.IncompleteTabDetails ?? [];
  
      // check incomplete conditions
      if (  (incompleteTabs && incompleteTabs.length > 0)) {
        this.showIncompleteTabsModal(incompleteTabs);
      }


    }
  );




}

  
  addUpdateold(reqBoby: any, Mode: number) {

    reqBoby.CommonArrivalScheduleRequestData.forEach((element: any) => {
      element.SaveMode = Mode
    });

    this.api.apiCall('VSApplication/SaveArrivalScheduleData', 'POST', reqBoby).subscribe((response: any) => {
   
      this.toastr.success(response?.Message);

      if (response.Data?.ProfileCompletionDetails?.CompletionPercentage < 80) {
        this.showIncompleteTabsModal(response.Data.IncompleteTabDetails);
      }
      else {
        if (Mode == this.SaveMode.SAVE) {
          this.FormApproveSucessfully();
        } else if (Mode == this.SaveMode.DRAFT) {
           this.getApplicantData();
        }
      }

     
    });
  }


  showIncompleteTabsModal(incompleteTabs: any[]) {
    const dialogRef = this.dialogService.open(FullScreenPopupComponent, {
      context: {
        title: 'Incomplete Tabs',
        message: 'Following tabs are incomplete. Please complete them before submission.',
        tabs: incompleteTabs

      },
      closeOnBackdropClick: false,
      hasScroll: true
    });

    dialogRef.onClose.subscribe(res => {
      if (res.isApproval) {
        // Proceed with the submission
        this.addUpdate(this.requestedDatesForm.value, this.SaveMode.SAVE);
      }
      if (res.isInvalidTabs) {
        this.navigateToInvalidTab.emit(res.tabData);
 
      }
    });
  }





  goToBack() {
    this.previous.emit();
  }

  // Translations
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }

  // Get retreat events from API
  getRetreatEvents(): void {
    this.api.apiCall('RetreatEvent/admin/retreat-events?onlyActive=true', 'GET').subscribe(
      (response: any) => {
        if (response.IsSuccess && response.Data && Array.isArray(response.Data)) {
          this.retreatEventsList = response.Data.map((event: any) => ({
            label: event.EventName,
            value: event.Id
          }));
        } else {
          this.retreatEventsList = [];
        }
      },
      (error: any) => {
        console.error('Error fetching retreat events:', error);
        this.retreatEventsList = [];
        this.toastr.error('Failed to load retreat events');
      }
    );
  }

  // Check if PTH application type
  get isPTHApplication(): boolean {
    return this.ApplicationTypeId == CONSTANTS.ApplicationTypeId.PTH;
  }

}
